<script setup lang="ts">
/**
 * @description UI-kit icon component — FontAwesome icon in a sized container
 * @category UI / Icons
 * @figma https://www.figma.com/design/CFyOwQUjj7uVRQTc03muvG/CS-UI-kit?node-id=216-127464
 */
// types
import type { AppIconProps } from '../types/interfaces'
// hooks
import { useAppIcon } from '../composables/use-app-icon.hook'
// components
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

defineOptions({
  name: 'AppIcon',
})

const props = withDefaults(defineProps<AppIconProps>(), {
  size: 'big',
  color: undefined,
})

const { classList } = useAppIcon({ props })
</script>

<template>
  <span :class="classList">
    <FontAwesomeIcon :icon="icon" />
  </span>
</template>

<style scoped lang="scss" src="../styles/_app-icon.scss" />
